import { render, staticRenderFns } from "./chatPollMessage.vue?vue&type=template&id=479ca025&scoped=true&lang=pug&"
import script from "./chatPollMessage.vue?vue&type=script&lang=js&"
export * from "./chatPollMessage.vue?vue&type=script&lang=js&"
import style0 from "./chatPollMessage.vue?vue&type=style&index=0&id=479ca025&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ca025",
  null
  
)

export default component.exports